function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import { setCheckoutDetailsValidation } from '../../../../../reducers/actions/offering.order.actions';
import { SelectedShippingAddressAndMethodSelector } from '../../../../../reducers/selectors/offering.order.selectors';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
export var EditCheckoutPopupController = /*#__PURE__*/function () {
  function EditCheckoutPopupController($ngRedux, $filter) {
    _classCallCheck(this, EditCheckoutPopupController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $filter: $filter,
      customerCareKeys: CustomerCareLocaleKeys,
      getEditModalTitle: this.getEditModalTitle.bind(this),
      handleDownPaymentChange: this.handleDownPaymentChange.bind(this),
      isFdoFormValid: this.isFdoFormValid.bind(this),
      getDeliveryMethodWithCurrency: this.getDeliveryMethodWithCurrency.bind(this),
      onEditExecutionOptionChange: this.onEditExecutionOptionChange.bind(this),
      onSelectEditOption: this.onSelectEditOption.bind(this),
      showErrorSummary: false,
      SIDE_NAV_FORMS: {
        BILLING_AND_SCHEDULING: 'editModalBillingAndSchedulingForm',
        DEVICE_PAYMENT: 'editModalDevicePaymentForm',
        SHIPPING: 'editModalShippingForm'
      },
      updateDeliveryMethod: this.updateDeliveryMethod.bind(this),
      updateProductIds: this.updateProductIds.bind(this)
    });
  }
  return _createClass(EditCheckoutPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          selectedShippingAddressAndMethod: SelectedShippingAddressAndMethodSelector(store)
        };
      };
      var controllerActions = {
        setCheckoutDetailsValidation: setCheckoutDetailsValidation
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.getEditModalNavList();
      if (this.editModalSideNavList.length) {
        this.editModalSideNavList.forEach(function (form) {
          _this.updateSelectedFormItems({
            formName: form.formName,
            isValid: null,
            glyph: 'empty',
            glyphClass: 'c-navGroup-emptyRouteIcon'
          });
        });
      }
      if (this.selectedItemFormName) {
        this.updateSelectedFormItems({
          formName: this.selectedItemFormName,
          isActive: true
        });
      }
      this.selectedDeliveryMethod = this.state.selectedShippingAddressAndMethod ? this.state.selectedShippingAddressAndMethod.methodId : undefined;
    }
  }, {
    key: "getEditModalTitle",
    value: function getEditModalTitle() {
      switch (this.selectedItemFormName) {
        case this.SIDE_NAV_FORMS.DEVICE_PAYMENT:
          return i18n.translate(this.customerCareKeys.CHECKOUT.DEVICE_PAYMENTS);
        case this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING:
          return i18n.translate(this.customerCareKeys.CHECKOUT.BILLING_SCHEDULING);
        case this.SIDE_NAV_FORMS.SHIPPING:
          return i18n.translate(this.customerCareKeys.CHECKOUT.SHIPPING);
        default:
          return '';
      }
    }
  }, {
    key: "getEditModalNavList",
    value: function getEditModalNavList() {
      var editModalSideNavList = [];
      var shippingNavObj = {
        formName: this.SIDE_NAV_FORMS.SHIPPING,
        glyph: 'empty',
        glyphClass: 'c-navGroup-emptyRouteIcon',
        id: this.SIDE_NAV_FORMS.SHIPPING,
        isActive: false,
        isDisabled: false,
        isHidden: false,
        isValid: null,
        label: i18n.translate(this.customerCareKeys.CHECKOUT.SHIPPING),
        tooltipMessage: null
      };
      var devicePaymentNavObj = {
        formName: this.SIDE_NAV_FORMS.DEVICE_PAYMENT,
        glyph: 'empty',
        glyphClass: 'c-navGroup-emptyRouteIcon',
        id: this.SIDE_NAV_FORMS.DEVICE_PAYMENT,
        isActive: false,
        isDisabled: this.isDevicePaymentsDisabled,
        isHidden: false,
        isValid: null,
        label: i18n.translate(this.customerCareKeys.CHECKOUT.DEVICE_PAYMENTS),
        tooltipMessage: i18n.translate(this.customerCareKeys.CHECKOUT.EDITABLE_AFTER_TOTALS_CALCULATED) // 'Editable after totals have been calculated'
      };
      var billingNavObj = {
        formName: this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING,
        glyph: 'empty',
        glyphClass: 'c-navGroup-emptyRouteIcon',
        id: this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING,
        isActive: false,
        isDisabled: false,
        isHidden: false,
        isValid: null,
        label: i18n.translate(this.customerCareKeys.CHECKOUT.BILLING_SCHEDULING),
        tooltipMessage: null
      };
      if (this.showDownPaymentsSchedulingAndBilling && this.financedItems.length && this.displaySummaryTab && !this.isDevicePaymentsHidden && this.isShipping) {
        editModalSideNavList.push(shippingNavObj);
        editModalSideNavList.push(devicePaymentNavObj);
        editModalSideNavList.push(billingNavObj);
      } else if (this.showDownPaymentsSchedulingAndBilling && this.financedItems.length && this.displaySummaryTab && !this.isDevicePaymentsHidden) {
        editModalSideNavList.push(devicePaymentNavObj);
        editModalSideNavList.push(billingNavObj);
      } else if (this.financedItems.length && this.displaySummaryTab && !this.isDevicePaymentsHidden && this.isShipping) {
        editModalSideNavList.push(devicePaymentNavObj);
        editModalSideNavList.push(shippingNavObj);
      } else if (this.showDownPaymentsSchedulingAndBilling && this.isShipping) {
        editModalSideNavList.push(shippingNavObj);
        editModalSideNavList.push(billingNavObj);
      }
      this.actions.setCheckoutDetailsValidation(editModalSideNavList);
    }
  }, {
    key: "onSelectEditOption",
    value: function onSelectEditOption(item) {
      this.itemSelected = item;
      this.selectedItemFormName = item.formName;
      if (item.formName === this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING) {
        this.editModalDevicePaymentForm.$setSubmitted(true);
        var isValid = !!this.editModalDevicePaymentForm.$valid;
        this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.DEVICE_PAYMENT, isValid);
        this.updateSelectedFormItems({
          formName: this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING,
          isActive: true
        });
      } else if (item.formName === this.SIDE_NAV_FORMS.DEVICE_PAYMENT) {
        this.editModalBillingAndSchedulingForm.$setSubmitted(true);
        var _isValid = !!this.editModalBillingAndSchedulingForm.$valid;
        this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING, _isValid);
        this.updateSelectedFormItems({
          formName: this.SIDE_NAV_FORMS.DEVICE_PAYMENT,
          isActive: true
        });
      } else if (item.formName === this.SIDE_NAV_FORMS.SHIPPING) {
        this.editModalShippingForm.$setSubmitted(true);
        var _isValid2 = !!this.editModalShippingForm.$valid;
        this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.SHIPPING, _isValid2);
        this.updateSelectedFormItems({
          formName: this.SIDE_NAV_FORMS.SHIPPING,
          isActive: true
        });
      }
    }
  }, {
    key: "updateEditFormValidationProperites",
    value: function updateEditFormValidationProperites(formName, isValid) {
      this.updateSelectedFormItems({
        formName: formName,
        isValid: isValid,
        glyph: isValid ? 'status-complete-filled' : 'status-pending-filled',
        glyphClass: isValid ? 'is-active' : 'is-removed'
      });
    }
  }, {
    key: "updateSelectedFormItems",
    value: function updateSelectedFormItems(itemObj) {
      this.actions.setCheckoutDetailsValidation(itemObj);
    }
  }, {
    key: "updateProductIds",
    value: function updateProductIds(pricingPlanId, pricingPlanProductId, offeringInstanceId, options) {
      this.updateSubscriberProductIds()(pricingPlanId, pricingPlanProductId, offeringInstanceId, options);
    }
  }, {
    key: "updateDeliveryMethod",
    value: function updateDeliveryMethod() {
      if (this.selectedItemFormName === this.SIDE_NAV_FORMS.SHIPPING) {
        var isValid = !!this.editModalShippingForm.$valid;
        this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.SHIPPING, isValid);
      }
    }
  }, {
    key: "onEditExecutionOptionChange",
    value: function onEditExecutionOptionChange(executionOptionsModel) {
      this.executionOptionsModel = executionOptionsModel;
      this.onExecutionOptionChange()(this.executionOptionsModel);
      if (this.selectedItemFormName === this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING) {
        var isValid = !!this.editModalBillingAndSchedulingForm.$valid;
        this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING, isValid);
      }
    }
  }, {
    key: "isFdoFormValid",
    value: function isFdoFormValid(isFormValid) {
      this.errorsExistOnForm = isFormValid;
      return isFormValid;
    }
  }, {
    key: "handleDownPaymentChange",
    value: function handleDownPaymentChange(itemIndex, item) {
      this.handleItemDownPaymentChanged()(itemIndex, item);
      if (this.selectedItemFormName === this.SIDE_NAV_FORMS.DEVICE_PAYMENT) {
        var isValid = !!this.editModalDevicePaymentForm.$valid;
        this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.DEVICE_PAYMENT, isValid);
      }
    }
  }, {
    key: "getDeliveryMethodWithCurrency",
    value: function getDeliveryMethodWithCurrency(option) {
      return option.label.concat(' ').concat(this.$filter('invCurrency')(option.cost, option.currency));
    }
  }, {
    key: "onSubmitEditCheckoutModal",
    value: function onSubmitEditCheckoutModal() {
      this.showErrorSummary = true;
      this.editModalBillingAndSchedulingForm.$setSubmitted(true);
      this.editModalDevicePaymentForm.$setSubmitted(true);
      this.editModalShippingForm.$setSubmitted(true);
      if (this.editModalDevicePaymentForm.$valid && this.editModalBillingAndSchedulingForm.$valid && (this.shippingAddress ? this.editModalShippingForm.$valid : true)) {
        if (this.selectedDeliveryMethod) {
          this.updateSelectedDeliveryMethod()(this.selectedDeliveryMethod);
        }
        this.onSubmitEditModal()(this.executionOptionsModel);
      } else {
        if (this.editModalBillingAndSchedulingForm.$valid) {
          var isValid = !!this.editModalBillingAndSchedulingForm.$valid;
          this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.BILLING_AND_SCHEDULING, isValid);
        }
        if (!this.editModalDevicePaymentForm.$valid) {
          var _isValid3 = !!this.editModalDevicePaymentForm.$valid;
          this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.DEVICE_PAYMENT, _isValid3);
        }
        if (!this.editModalShippingForm.$valid) {
          var _isValid4 = !!this.editModalShippingForm.$valid;
          this.updateEditFormValidationProperites(this.SIDE_NAV_FORMS.SHIPPING, _isValid4);
        }
        this.updateSelectedFormItems({
          formName: this.selectedItemFormName,
          isActive: true
        });
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./edit.checkout.popup.html'),
  bindings: {
    billCycleOptions: '<',
    billCycleSelectOptionTemplate: '<',
    billingEffectiveDateOptions: '<',
    billingEffectiveDateSettings: '<',
    canShowFdoAndBed: '<',
    cartHasOfferWithBillerRuleCycleLevelOtherThanItem: '<?',
    closeEditCheckoutPageInformationPopup: '&',
    currentCustomerId: '<',
    displaySummaryTab: '<',
    edit: '<',
    editModalSideNavList: '<',
    executionOptions: '<',
    executionOptionsMinDate: '<',
    fdoMaxDate: '<',
    financedItems: '<',
    handleItemDownPaymentChanged: '&',
    isAlignRenewals: '<',
    isBillCycleEditDisabled: '<?',
    isBillingEffectiveDateShown: '<?',
    isDbss: '<?',
    isDevicePaymentsHidden: '<?',
    isDevicePaymentsDisabled: '<?',
    isFirstOrder: '<?',
    isOrderPostPaid: '<?',
    isShipping: '<?',
    shipTo: '<?',
    shippingAddress: '<?',
    deliveryMethodOptions: '<?',
    formatedCityStateForShippingAddress: '<?',
    offCycleAlignmentOptions: '<',
    onBillCycleSelectOptionSelected: '&?',
    onExecutionOptionChange: '&',
    onFdoFormValidityChange: '&',
    onSubmitEditModal: '&',
    renewalData: '<?',
    selectedBillCycle: '<?',
    selectedItemFormName: '<?',
    showAlignRenewals: '<?',
    showBillCycleOption: '<',
    showDownPaymentsSchedulingAndBilling: '<',
    showSideNavEditModal: '<',
    transferFromSubscriberId: '<?',
    updateSubscriberProductIds: '&?',
    updateSelectedDeliveryMethod: '&?'
  },
  controller: EditCheckoutPopupController
};